/**
 * Auto-generated service - DO NOT EDIT MANUALLY
 * Generated from: manual_action.ts
 * Run: pnpm gen
 */

import { API_METHODS } from '../constants/api-methods';
import { getApiPath } from '../path';
import { type RequestOptions, type Transport } from '../transport';

import type {
  ExecuteAttachToCaseActionRequest,
  ExecuteAttachToCaseActionResponse,
  ExecuteAuditActionRequest,
  ExecuteAuditActionResponse,
  ExecuteAwaitingReviewActionRequest,
  ExecuteAwaitingReviewActionResponse,
  ExecuteCallActionRequest,
  ExecuteCallActionResponse,
  ExecuteEligibilityCheckAuditActionRequest,
  ExecuteEligibilityCheckAuditActionResponse,
  ExecuteEmailExchangeActionRequest,
  ExecuteEmailExchangeActionResponse,
  ExecuteFillMissingInfoActionRequest,
  ExecuteFillMissingInfoActionResponse,
  ExecuteIntakeDraftActionRequest,
  ExecuteIntakeDraftActionResponse,
  ExecutePortalSessionActionRequest,
  ExecutePortalSessionActionResponse,
  ExecuteRegenerateCaseSummaryActionRequest,
  ExecuteRegenerateCaseSummaryActionResponse,
  ExecuteResendEmailActionRequest,
  ExecuteResendEmailActionResponse,
  ExecuteReviewActionRequest,
  ExecuteReviewActionResponse,
} from '../types/manual_action';

export const createManualActionService = (transport: Transport) => ({
  async executeAuditAction(
    request: ExecuteAuditActionRequest,
    options: RequestOptions = {},
  ): Promise<ExecuteAuditActionResponse> {
    const { organization_id, program_id, case_record_id, ...body } = request;
    const url = getApiPath(API_METHODS.ManualActionService.ExecuteAuditAction, {
      organization_id,
      program_id,
      case_record_id,
    });
    return transport.post<ExecuteAuditActionResponse>(url, body, options);
  },

  async executeCallAction(
    request: ExecuteCallActionRequest,
    options: RequestOptions = {},
  ): Promise<ExecuteCallActionResponse> {
    const { organization_id, program_id, case_record_id, ...body } = request;
    const url = getApiPath(API_METHODS.ManualActionService.ExecuteCallAction, {
      organization_id,
      program_id,
      case_record_id,
    });
    return transport.post<ExecuteCallActionResponse>(url, body, options);
  },

  async executeFillMissingInfoAction(
    request: ExecuteFillMissingInfoActionRequest,
    options: RequestOptions = {},
  ): Promise<ExecuteFillMissingInfoActionResponse> {
    const { organization_id, program_id, case_record_id, ...body } = request;
    const url = getApiPath(API_METHODS.ManualActionService.ExecuteFillMissingInfoAction, {
      organization_id,
      program_id,
      case_record_id,
    });
    return transport.post<ExecuteFillMissingInfoActionResponse>(url, body, options);
  },

  async executeEligibilityCheckAuditAction(
    request: ExecuteEligibilityCheckAuditActionRequest,
    options: RequestOptions = {},
  ): Promise<ExecuteEligibilityCheckAuditActionResponse> {
    const { organization_id, program_id, case_record_id, ...body } = request;
    const url = getApiPath(API_METHODS.ManualActionService.ExecuteEligibilityCheckAuditAction, {
      organization_id,
      program_id,
      case_record_id,
    });
    return transport.post<ExecuteEligibilityCheckAuditActionResponse>(url, body, options);
  },

  async executeIntakeDraftAction(
    request: ExecuteIntakeDraftActionRequest,
    options: RequestOptions = {},
  ): Promise<ExecuteIntakeDraftActionResponse> {
    const { organization_id, program_id, case_record_id, ...body } = request;
    const url = getApiPath(API_METHODS.ManualActionService.ExecuteIntakeDraftAction, {
      organization_id,
      program_id,
      case_record_id,
    });
    return transport.post<ExecuteIntakeDraftActionResponse>(url, body, options);
  },

  async executeReviewAction(
    request: ExecuteReviewActionRequest,
    options: RequestOptions = {},
  ): Promise<ExecuteReviewActionResponse> {
    const { organization_id, program_id, case_record_id, ...body } = request;
    const url = getApiPath(API_METHODS.ManualActionService.ExecuteReviewAction, {
      organization_id,
      program_id,
      case_record_id,
    });
    return transport.post<ExecuteReviewActionResponse>(url, body, options);
  },

  async executeEmailExchangeAction(
    request: ExecuteEmailExchangeActionRequest,
    options: RequestOptions = {},
  ): Promise<ExecuteEmailExchangeActionResponse> {
    const { organization_id, program_id, case_record_id, ...body } = request;
    const url = getApiPath(API_METHODS.ManualActionService.ExecuteEmailExchangeAction, {
      organization_id,
      program_id,
      case_record_id,
    });
    return transport.post<ExecuteEmailExchangeActionResponse>(url, body, options);
  },

  async executeAwaitingReviewAction(
    request: ExecuteAwaitingReviewActionRequest,
    options: RequestOptions = {},
  ): Promise<ExecuteAwaitingReviewActionResponse> {
    const { organization_id, program_id, case_record_id, ...body } = request;
    const url = getApiPath(API_METHODS.ManualActionService.ExecuteAwaitingReviewAction, {
      organization_id,
      program_id,
      case_record_id,
    });
    return transport.post<ExecuteAwaitingReviewActionResponse>(url, body, options);
  },

  async executeResendEmailAction(
    request: ExecuteResendEmailActionRequest,
    options: RequestOptions = {},
  ): Promise<ExecuteResendEmailActionResponse> {
    const { organization_id, program_id, case_record_id, ...body } = request;
    const url = getApiPath(API_METHODS.ManualActionService.ExecuteResendEmailAction, {
      organization_id,
      program_id,
      case_record_id,
    });
    return transport.post<ExecuteResendEmailActionResponse>(url, body, options);
  },

  async executeAttachToCaseAction(
    request: ExecuteAttachToCaseActionRequest,
    options: RequestOptions = {},
  ): Promise<ExecuteAttachToCaseActionResponse> {
    const { organization_id, program_id, case_record_id, ...body } = request;
    const url = getApiPath(API_METHODS.ManualActionService.ExecuteAttachToCaseAction, {
      organization_id,
      program_id,
      case_record_id,
    });
    return transport.post<ExecuteAttachToCaseActionResponse>(url, body, options);
  },

  async executeRegenerateCaseSummaryAction(
    request: ExecuteRegenerateCaseSummaryActionRequest,
    options: RequestOptions = {},
  ): Promise<ExecuteRegenerateCaseSummaryActionResponse> {
    const { organization_id, program_id, case_record_id, ...body } = request;
    const url = getApiPath(API_METHODS.ManualActionService.ExecuteRegenerateCaseSummaryAction, {
      organization_id,
      program_id,
      case_record_id,
    });
    return transport.post<ExecuteRegenerateCaseSummaryActionResponse>(url, body, options);
  },

  async executePortalSessionAction(
    request: ExecutePortalSessionActionRequest,
    options: RequestOptions = {},
  ): Promise<ExecutePortalSessionActionResponse> {
    const { organization_id, program_id, case_record_id, ...body } = request;
    const url = getApiPath(API_METHODS.ManualActionService.ExecutePortalSessionAction, {
      organization_id,
      program_id,
      case_record_id,
    });
    return transport.post<ExecutePortalSessionActionResponse>(url, body, options);
  },
});

export type ManualActionService = ReturnType<typeof createManualActionService>;
